/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Base Styles
import borders from "assets/theme/base/borders";

// Material Dashboard 2 React Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

// ⬆️ On récupère les tailles de bordures configurées globalement
const { borderRadius } = borders;

const cardMedia = {
  styleOverrides: {
    root: {
      // ✅ Coins arrondis harmonisés avec les autres composants (lg au lieu de md)
      borderRadius: borderRadius.lg,

      // ✅ Marge supérieure uniquement (alignement visuel)
      margin: `${pxToRem(16)} ${pxToRem(24)} 0`,

      // ✅ S’assure que l’image couvre l’espace sans déformation
      objectFit: "cover",

      // ✅ Prend toute la largeur de la carte
      width: "100%",

      // ✅ Hauteur max adaptée pour affichage responsive
      maxHeight: pxToRem(180),
    },

    media: {
      // ✅ Largeur forcée pour images secondaires si utilisées
      width: "100%",
    },
  },
};

export default cardMedia;
